import React, {useEffect, useState} from 'react';
import {IconButton, InputAdornment, SxProps, TextField} from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import ClearIcon from "@mui/icons-material/Clear"

interface SearchInputProps {
    onThrottledChange: (newValue: string | undefined) => void
    sx?: SxProps
    autoFocus?: boolean
    /**
     * When provided, the floating "Search" label is replaced with this placeholder.
     * Useful in tight toolbars where a floating label causes layout jank during
     * width transitions (MUI's outlined label sits on the border and clips during
     * horizontal Collapse animations).
     */
    placeholder?: string
}

function SearchInput({onThrottledChange, sx, autoFocus, placeholder}: SearchInputProps) {
    const [value, setValue] = useState<string>()

    // Throttle loading from changes in the search string
    let timer: NodeJS.Timeout | null = null
    useEffect(() => {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => onThrottledChange(value), 250)
        return () => {
            if (timer) clearTimeout(timer)
        }
    }, [value])

    return (
        <TextField
            id="outlined-search"
            label={placeholder ? undefined : "Search"}
            placeholder={placeholder}
            value={value ?? ""}
            sx={sx}
            autoFocus={autoFocus}
            InputProps={{
                startAdornment:
                    <InputAdornment position="start">
                        <SearchIcon/>
                    </InputAdornment>
                ,
                endAdornment: value &&
                    <InputAdornment position="end">
                        <IconButton size="small" edge="end" onClick={() => setValue(undefined)}>
                            <ClearIcon/>
                        </IconButton>
                    </InputAdornment>,
            }}
            size="small"
            onChange={(e) => setValue(e.target.value)}
        />
    );
}

export default SearchInput;